import { ConnectAlternative } from '../../../screens/manage/connect/connect-alternative';
import { dailymotionConnectMessages as messages } from './dailymotion-connect-messages';

/** Dailymotion connect alternatives: OAuth login (recommended) or API-key flow. */
export const dailymotionConnectAlternatives: ConnectAlternative[] = [
  {
    id: 'login',
    name: messages.loginName,
    description: messages.loginDescription,
    action: { type: 'oauth' },
    icon: 'login',
    recommended: true,
  },
  {
    id: 'api-key',
    name: messages.apiKeyName,
    description: messages.apiKeyDescription,
    action: { type: 'route', to: '/admin/social-export/dailymotion/connect' },
    icon: 'key',
  },
];
